export default __webpack_public_path__ + "sideBar.5176d19.png";